import * as React from 'react';
import { classes, st } from './ColorPicker.st.css';
import { ColorPickerBase } from './ColorPicker.base';
import { generateKey } from '../../common/random';
import { ColorPickerProps } from './types';

/** ColorPicker */
export class ColorPicker extends React.Component<ColorPickerProps> {
  private readonly _groupName: string;
  static displayName = 'ColorPicker';

  constructor(props) {
    super(props);

    this._groupName = generateKey('ColorPicker_group');
  }

  static Item = ColorPickerBase.Item;

  render() {
    const { className, name, ...rest } = this.props;

    return (
      <ColorPickerBase
        {...rest}
        name={name || this.props['aria-label'] || this._groupName}
        className={st(classes.root, className)}
      />
    );
  }
}
